export default __webpack_public_path__ + "static/logo-2cca34b5bd9e433eb607a1a9c9ebf744.svg";